<div *ngIf="isFansZero" class="alert valign-children-middle" id="error-main-container">
 <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
     <i class="icon-badgealert"></i>
 </div>
 <div>
     <h2>Error</h2>
     <p class="error-message"> </p>
 </div>
</div>
<div *ngIf="showGoogleCreationError" id="alertMessage" class="alert valign-children-middle">
 <div class="alert-error" role="img" aria-label="Alert">
   <i class="icon-badgealert"></i>
 </div>
 <div>
   <span *ngIf="showGoogleCreationError"> &nbsp;<a href="#" (click)="backToProductSelection($event)">
        </a>&nbsp;
        </span>
   <span *ngIf="!showGoogleCreationError"> </span>
 </div>
</div>
<div class="main-wrapper" *ngIf="!isFansZero">
   <section class="signup-section accounts-tab" >
 
   <section class="signupwithnotab" >
     <div>
      <h2>Select foundation accounts</h2>
      <p>
        <span>Select the foundation accounts you want to include in your device enrollment. You can set up each of your foundation accounts in different device enrollment programs, if you choose. You can repeat these steps for another selection after completing this enrollment. Note: You won't be able to change the account selection after you click Continue. For more information about Android Zero-touch, see the <a>Android Zero-touch Service Guide</a>.</span>
         <!-- <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp"> Service Guide</a>
         <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">  Service Guide</a>
         <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank" *ngIf="abm">  User Guide</a>. -->
       </p>
       <br>
       <p>You've selected {{eligibleFanCount}} accounts. </p>
       <br>
     </div>
     <div class="tooltip-input inline-labels">
       <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
       (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
       <div role="tooltip" class="helper-text" id="inputhelp"> </div>
     </div>
     <app-customgrid [gridOptions]="gridOptions[0]" (onDataChange)="onRowClick($event)" >
      <ng-template let-row="row">
        <label class="checkbox" id="enroll-label">
         <input type="checkbox" aria-describedby="enroll-existing-devices" aria-label="Enroll" name="enroll-devices" 
         (click)="existingDevices(row)" [disabled]="!row.selected" [(ngModel)]="row.enroll"
         [ngModelOptions]="{standalone: true}">
          <i class="skin"></i>
          <span id="enroll-existing-devices"> enroll </span>
        </label>
        
      </ng-template>
      
    </app-customgrid>
 
     
     <br>
 
     <div class="legalAgreement">
       <h3> Legal Agreements</h3>
       <br/>

       <p> Use of AT&T's Device Management Program is subjected to the <a>Terms of Use for AT&T's Device Management Program</a>.Use of Android Zero-touch is subject to the Terms & Conditions in the <a href="assets/pdf/GoogleZTP.pdf" target="_blank">Android Zero-touch Service Guide</a>.</p>
       <!-- <p> 
         <a [href]=" " target="_blank"> </a>.
       </p>
       <p  *ngIf="!abm">Use of Android Zero-touch is subject to the Terms & Conditions in the 
         <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">Android Zero-touch Service Guide</a>
         <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">Android Zero-touch Service Guide</a>
       </p>
       <p *ngIf="abm">Use of Android Zero-touch is subject to the Terms & Conditions on the 
         <a href="https://business.apple.com" target="_blank" *ngIf="abm">Android Zero-touch portal</a>.
       </p> -->
     </div>

     <section class="buttons-section col-sm-12 col-md-12  text-right">
       <button  (click)="continueToNext()" aria-label="Continue."
         href="javascript:void(0)" class="btn btn-secondary pull-right"> Continue  </button>
       <a id="cancel" (click)="backToInitialSetup($event)" class="btn btn-link btn-block btn-cancel"> Cancel </a>
     </section>
 
   </section>

 
   <section class="signuptabcontainer" *ngIf="haveTab">
     <app-tabs [tabs]="tabArray" [ariaLabel]="'Device enrollment'">
       <app-tab class="app-tab" *ngFor='let td of tabArray; let i = index;' [option]="td" (click)="selectedTab(i);">
         <div>
           <p>
             <span>  </span>
             <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">Android Zero-touch Service Guide</a>
             <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">Android Zero-touch Service Guide</a>
             <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank" *ngIf="abm">Android Zero-touch Service Guide</a>.
           </p>
           <p *ngIf="!selectedFansCount[i]"> </p>
           <p *ngIf="selectedFansCount[i]">  </p>
         </div>
         <div class="tooltip-input inline-labels">
           <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
           (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
           <div role="tooltip" class="helper-text" id="inputhelp"> </div>
         </div>
         <!-- <app-customgrid *ngIf="td.isActive" [gridOptions]="gridOptions[i]" (onDataChange)="onRowClick($event)">
           
           <ng-template let-row="row">
             <label class="checkbox" id="enroll-label">
               <input type="checkbox" #enrollBox aria-describedby="enroll-existing-devices" aria-label="Enroll" name="enroll-devices" 
                 (click)="existingDevices(row)" [disabled]="!this.enrollEnable">
               <i class="skin"></i>
               <span id="enroll-existing-devices">  </span>
             </label>
           </ng-template>
         </app-customgrid> -->
 
         <br>
         
         <div class="legalAgreement">
           <h3> </h3>
           <br/>
           <p> 
             <a [href]="staticTcUrl" target="_blank"> </a>.
           </p>
           <p>Use of Android Zero-touch is subject to the Terms & Conditions in the 
             <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">Android Zero-touch Service Guide</a>
             <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">Android Zero-touch Service Guide</a>
             <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank" *ngIf="abm">Android Zero-touch Service Guide</a>.
           </p>
         </div>
 
         <section class="buttons-section col-sm-12 col-md-12 text-right">
           <button id="accounts-btn" [disabled]="!this.enableCont || showError" 
            (click)="continueToNext()" href="javascript:void(0)"
             class="btn btn-secondary pull-right">Continue </button>
           <a href="#" (click)="backToInitialSetup($event)" class="btn btn-link bt-block btn-cancel"> Cancel </a>
         </section>
       </app-tab>
     </app-tabs>
   </section>
   
 </section>
 </div>
 